/* NightHaven: haelt die Warenkorb-Zahl am Shopping-Bag aktuell */
(function () {
  var CART_RE = /\/cart\/(add|change|update|clear)/;

  function setCount(n) {
    if (typeof n !== 'number') return;
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', n);
      el.textContent = '(' + n + ')';
    });
  }

  function refresh() {
    var base = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    nativeFetch(base + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) setCount(cart.item_count); })
      .catch(function () {});
  }

  function later() { setTimeout(refresh, 150); }

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(window, arguments);
    if (CART_RE.test(url)) { p.then(later, function () {}); }
    return p;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url || ''))) { this.addEventListener('load', later); }
    return nativeOpen.apply(this, arguments);
  };

  document.addEventListener('theme:cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && typeof cart.item_count === 'number') { setCount(cart.item_count); } else { refresh(); }
  });

  document.addEventListener('DOMContentLoaded', refresh);
})();
